import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDFZGZC9Nj0MD86Jbrw6NRqbG_doSX9g_s",
  authDomain: "procode-a597a.firebaseapp.com",
  projectId: "procode-a597a",
  storageBucket: "procode-a597a.firebasestorage.app",
  messagingSenderId: "648886413900",
  appId: "1:648886413900:web:17c76de74e3f6c7cafa2e9"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;